module.exports = __webpack_public_path__ + "img/header.725ea4cd.png";